import { SettingReceptionInformationContainer } from "../";

export const SettingReceptionMainContainer = () => {
  return (
    <div className="productDetailMainContainer">
      <SettingReceptionInformationContainer />
    </div>
  );
};
